import { Loading } from '../volumenes/_index';

export class Nodo {

    idNodo: number;
    nombre: string;
    codigo: string;
    tieneHijos: boolean;
    nivel: number;
    latitud: string;
    longitud: string;
    cp: string;

    profundidad: number;
    hijoExpandidoIndex: number;
    selected: boolean;
    indeterminate: boolean;
    visible: boolean = true;

    expandido: boolean = false;

    incluirDiscontinuadas: boolean;
    incluirParciales: boolean;

    cargandoHijos: boolean = false;

    activo: boolean = true;

    idSegmento: number = -1;

    loading: Loading = new Loading();

    constructor(params = undefined) {
        if (params != undefined) {
            this.profundidad = params.profundidad;
            this.hijoExpandidoIndex = params.hijoExpandidoIndex;
            this.selected = params.selected ? params.selected : false;
            this.indeterminate = params.indeterminate ? params.indeterminate : false;
            this.idSegmento = params.idSegmento;
        }
    }

    public expandirHijo(index: number): void {
        if (this.hijoExpandidoIndex == index) {
            this.hijoExpandidoIndex = undefined;
        }
        else {
            this.hijoExpandidoIndex = index;
        }
    }

    public expandirHijoConDisabled(index: number, disabled: boolean): void {
        if (!disabled) {
            if (this.hijoExpandidoIndex == index) {
                this.hijoExpandidoIndex = undefined;
            }
            else {
                this.hijoExpandidoIndex = index;
            }
        }
    }

}   